import Vue from 'vue'
import axios from 'axios'
import router from './router/router'
import store from './store'
import { sync } from 'vuex-router-sync'
import App from './app'
import VueAxios from 'vue-axios'
import VueAuth from '@websanova/vue-auth'
import Notifications from 'vue-notification'
import BootstrapVue from 'bootstrap-vue'
import SingalR from './signalr';
import runtimeConfig, { loadRuntimeConfig } from 'common/runtime-config';

import './css/font.css';
import './css/site.css';

// Two deployments build from this entry point:
//
//   hosted — served from notice-board.<fqdn> alongside the other SPAs. The API
//     and SignalR live on their own subdomains, and the board identifies itself
//     with the ?dnb=&key= pair carried by the PMS preview link, exchanged below
//     for a token whose SerialNumber claim is the board id.
//   local (default) — runs on a Pi, where Shield.LocalConfig serves /api/ on the
//     device and identifies the board itself, so no token is involved.
//
// The pipeline selects hosted by copying .env.<environment> over .env.production;
// a plain `npm run build` keeps the Pi defaults.
const hosted = process.env.VUE_APP_NOTICE_BOARD_HOSTED === 'true';

window.authRequired = hosted;
window.expectSignalrHeartbeat = !hosted;

// Assigned once the app is mounted, below.
let app;

Vue.use(VueAxios, axios);
Vue.use(Notifications);
Vue.use(BootstrapVue);

import jquery from 'jquery';
window.$ = jquery;
window.jQuery = jquery;

import Loading from './components/loading'
Vue.component('loading', Loading);


Vue.router = router;
if (authRequired) {
    Vue.use(VueAuth, {
        auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
        http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
        router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
        loginData: { url: 'authentication/request-token', method: 'POST', redirect: '/', fetchUser: false },
        fetchData: { url: 'authentication/user', method: 'GET', enabled: true },
        refreshData: { url: 'authentication/refresh-token', method: 'GET', enabled: true, interval: 20 }
    });

   

} else {
    Vue.prototype.$auth = null;
}

// signalr.js binds window.signalRurl when Vue.use installs it, so both URLs have
// to be resolved before the plugin — and the app — start. On a Pi nothing serves
// config.json and loadRuntimeConfig just keeps the build-time values.
loadRuntimeConfig().then(startApp);

function startApp() {
    if (hosted) {
        // home-page.vue builds picture URLs by concatenating baseURL onto a
        // relative path, so it has to keep its trailing slash.
        axios.defaults.baseURL = `${runtimeConfig.apiUrl.replace(/\/+$/, '')}/`;
        window.signalRurl = `${runtimeConfig.signalrUrl.replace(/\/+$/, '')}/noticeboardhub`;
    } else {
        axios.defaults.baseURL = '/api/';
        window.signalRurl = '/signalr/noticeboardhub';
    }

    Vue.use(SingalR);

    sync(store, router)

    Vue.config.productionTip = false

    if (authRequired) {
        var urlParams = new URLSearchParams(window.location.search);
        var dnb = urlParams.get("dnb");
        var key = urlParams.get("key");
        var themeId = urlParams.get("themeId");

        var auth = axios.post("/authentication/request-token", { username: "dnr::" + dnb, password: key });

        //108 is ID of the dummy board for message previews
        if (dnb != 108) {
            auth.then(tokenResponse => {
                var token = tokenResponse.data.token;

                if (token) {
                    axios.get("/DigitalNoticeBoard/theme", {
                        headers: {
                            Authorization: "Bearer " + token
                        }
                    }).then(themeResponse => {
                        var theme = themeResponse.data;
                        if (theme) {
                            Vue.prototype.$kmsTheme = theme;
                        } else {
                            Vue.prototype.$kmsTheme = null;
                        }

                        app = new Vue({
                            router,
                            store,
                            render: h => h(App)
                        }).$mount('#app')
                    })
                }
            });
        } else if (dnb == 108 && themeId) {
            auth.then(tokenResponse => {
                var token = tokenResponse.data.token;

                if (token) {
                    axios.get("/DigitalNoticeBoard/theme-by-id", {
                        params: {
                            id: themeId
                        },
                        headers: {
                            Authorization: "Bearer " + token
                        }
                    }).then(themeResponse => {
                        var theme = themeResponse.data;
                        if (theme) {
                            Vue.prototype.$kmsTheme = theme;
                        } else {
                            Vue.prototype.$kmsTheme = null;
                        }

                        app = new Vue({
                            router,
                            store,
                            render: h => h(App)
                        }).$mount('#app')
                    })
                }
            });
        } else {
            Vue.prototype.$kmsTheme = null;

            app = new Vue({
                router,
                store,
                render: h => h(App)
            }).$mount('#app')
        }

    } else {
        axios.get("/DigitalNoticeBoard/theme").then(themeResponse => {
            var theme = themeResponse.data;
            if (theme) {
                Vue.prototype.$kmsTheme = theme;
            }

            app = new Vue({
                router,
                store,
                render: h => h(App)
            }).$mount('#app')
        })
    }
}




export {
    app,
    router,
    store
}